import {UserStore} from "@/store/user";
import {shallow} from "zustand/shallow";

export const useAuthContext = () => {
    const context = UserStore(state => state, shallow);

    if (!context) throw new Error('useAuthContext context must be use inside AuthProvider');

    return context;
};
